<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Ano / Mês">
                <b-form-input type="number" step="1" min="0" name="ym" v-model="item.ym" placeholder="Ano / Mês"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Spreads" >
                <b-form-select :options="lists.yesNo" name="spreads" v-model="item.spreads" placeholder="Estado"  v-validate="'required'" :state="validateState('spreads')" ></b-form-select>

                <b-form-invalid-feedback>
                  {{ errors.first('code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <modal-select modal="dealers-modal" v-validate="'required'" name="dealer_id" v-bind:readonly="item.id>0" v-bind:item-id="item.dealer_id" v-bind:item-name="item.dealer.data.name" v-on:select-item="selectDealer"  :state="validateState('dealer_id')"  ></modal-select>
          <modal-select modal="zones-modal"  name="dealer_zone_id" v-bind:readonly="item.id>0" v-bind:item-id="item.dealer_zone_id" v-bind:item-name="item.zone.data.name" v-on:select-item="selectZone"  :state="validateState('dealer_zone_id')"  ></modal-select>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="Sellout Top10">
                <b-form-input type="number" step="0.01" min="0" name="sellout1" v-model="item.sellout1" placeholder="Sellout Top10"  v-validate="'required'" :state="validateState('sellout1')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellout1') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Sellout Total">
                <b-form-input type="number" step="0.01" min="0" name="sellout2" v-model="item.sellout2" placeholder="Sellout Total"  v-validate="'required'" :state="validateState('sellout2')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellout2') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="4">
              <b-form-group label="Sellin Top10">
                <b-form-input type="number" step="0.01" min="0" name="sellin1" v-model="item.sellin1" placeholder="Sellin Top10"  v-validate="'required'" :state="validateState('sellin1')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellin1') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Sellin Total">
                <b-form-input type="number" step="0.01" min="0" name="sellin2" v-model="item.sellin2" placeholder="Sellin Total"  v-validate="'required'" :state="validateState('sellin2')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellin2') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="Operadores Acumulados">
                <b-form-input type="number" step="1" min="0" name="operators1" v-model="item.operators1" placeholder="Operadores Acumulados"  v-validate="'required'" :state="validateState('operators1')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('operators1') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Sum Top10">
                <b-form-input type="number" step="1" min="0" name="operators2" v-model="item.operators2" placeholder="Sum Top10"  v-validate="'required'" :state="validateState('operators2')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('operators2') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'scorecard_objectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: {  },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      item: {

        zone: {
          data: {
            id: null,
            name: ''
          }
        },
        dealer: {
          data: {
            name: '',
            id: null
          }
        },
        sellout1: 0,
        sellout2: 0,
        sellout3: 0,
        sellin1: 0,
        sellin2: 0,
        sellin3: 0,
        operators1: 0,
        operators2: 0
      }
    }
  },
  methods: {
    selectDealer(e) {
      this.item.dealer_id = e.item.id
      this.item.dealer.data = e.item
    },
    selectZone(e) {
      this.item.zone = e.item.zone
      this.$refs.dealersModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('scorecard/objectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'scorecard_objectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('scorecard/objectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'scorecard_objectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('scorecard/objectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer) {
            this.item.dealer = {
              data: {}
            }
          }
          if(!this.item.zone) {
            this.item.zone = {
              data: {}
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'scorecard_objectives.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
